import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const Message = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
  display: flex;
  gap: 16px;
  justify-content: space-between;

  @media (max-width: ${theme.v2.breakpoints.sm}) {
    flex-direction: column;
    gap: 16px;

    & > button:first-child {
      order: 3;
    }

    & > button:nth-child(2) {
      order: 2;
    }

    & > button:last-child {
      order: 1;
    }
  }

  `}
`;

export const RebootInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 24px;
    padding: 16px;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
  `}
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 83px;
`;

export const InfoName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowMedium};
  `}
`;

export const InfoValue = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
  `}
`;

export const HistoryActions = styled.div`
  display: flex;
  justify-content: center;
`;
